<template>
  <div class="comments">
    <span class="comments__control">
      <button class="comments__button" @click="isCommenting = !isCommenting">
        Комментировать
      </button>
      <button class="comments__button" @click="showComments = !showComments">
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.6792 9.21227L11.2339 8.98483L11.1273 9.19368L11.2196 9.40923L11.6792 9.21227ZM9.90276 11.2617L10.0609 10.7874L9.82081 10.7073L9.61417 10.8534L9.90276 11.2617ZM13 12.2941L12.8419 12.7685L13.8982 13.1206L13.4596 12.0972L13 12.2941ZM11.7941 6.64706C11.7941 7.48981 11.592 8.28389 11.2339 8.98483L12.1245 9.43971C12.5528 8.6012 12.7941 7.65159 12.7941 6.64706H11.7941ZM6.64706 1.5C9.4897 1.5 11.7941 3.80442 11.7941 6.64706H12.7941C12.7941 3.25213 10.042 0.5 6.64706 0.5V1.5ZM1.5 6.64706C1.5 3.80442 3.80442 1.5 6.64706 1.5V0.5C3.25213 0.5 0.5 3.25213 0.5 6.64706H1.5ZM6.64706 11.7941C3.80442 11.7941 1.5 9.4897 1.5 6.64706H0.5C0.5 10.042 3.25213 12.7941 6.64706 12.7941V11.7941ZM9.61417 10.8534C8.77571 11.446 7.75278 11.7941 6.64706 11.7941V12.7941C7.96618 12.7941 9.18961 12.378 10.1914 11.67L9.61417 10.8534ZM9.74465 11.736L12.8419 12.7685L13.1581 11.8198L10.0609 10.7874L9.74465 11.736ZM13.4596 12.0972L12.1388 9.01531L11.2196 9.40923L12.5404 12.4911L13.4596 12.0972Z"
            fill="#697178"
          />
        </svg>
        <span class="comments__control-count">{{ count }}</span>
      </button>
    </span>

    <transition-group name="fade">
      <div
        v-show="showComments && index < shownCount"
        v-for="(item, index) in comments"
        :key="index + 'comments'"
        class="comments__item"
        :style="item.comment_id ? 'padding-left: 53px' : null"
      >
        <div class="author">
          <div class="user-avatar comment-avatar">
            <img
              v-if="item.sender && item.sender.avatar"
              :src="item.sender.avatar.url"
              :alt="item.sender.full_name"
            />
            <img v-else src="/img/avatar-thumb.png" :alt="item.full_name" />
          </div>
        </div>

        <div>
          <div class="comments__item-content">
            <div class="menu" style="padding: 0">
              <div
                v-if="item.sender_id === currentUserData.id"
                class="menu__button"
                @click.stop="controlMenuIndex = controlMenuIndex === index ? null : index"
              >
                <svg
                  width="15"
                  height="3"
                  viewBox="0 0 15 3"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="1.95652"
                    cy="1.30435"
                    r="1.30435"
                    fill="#95A4C0"
                  />
                  <circle
                    cx="7.17392"
                    cy="1.30435"
                    r="1.30435"
                    fill="#95A4C0"
                  />
                  <circle
                    cx="12.3913"
                    cy="1.30435"
                    r="1.30435"
                    fill="#95A4C0"
                  />
                </svg>
              </div>
              <div class="menu__controls" style="right: 0">
                <transition name="fade">
                  <AppPopupControls
                    v-if="controlMenuIndex === index"
                    :active-buttons="{ add: false, edit: true, remove: true }"
                    @edit-this-item="setEdit(item)"
                    @remove-this-item="deleteComment(item.id)"
                    @close="controlMenuIndex = null"
                  />
                </transition>
              </div>
            </div>
            <p>{{ getFullUser(item.sender_id) || item.sender.name.trim() }}
            </p>
            <!-- <b v-if="item.comment_id && comments[index - 1]">{{ getFullUser(comments[index - 1].sender_id) || comments[index - 1].sender.name }}, </b> -->
            <span class="plain-html" v-html="item.content" />
            <AppMessageAttachmentPreview
              :files="item.files || []"
              :tags="item.tags || []"
            />
          </div>
          <button v-if="!item.comment_id" @click="setAnswer(item)" class="comments__button">Ответить</button>
        </div>
      </div>
    </transition-group>

    <div
      v-if="showComments && comments.length > shownCount"
      class="comments__item-more"
    >
      <button @click="shownCount += shownCount">Показать еще</button>
    </div>

    <transition name="fade-comments">
      <div class="comments__field" v-if="isCommenting" ref="commentField">
        <div class="author">
          <div class="user-avatar comment-avatar">
            <img
              v-if="currentUserData.avatar"
              :src="currentUserData.avatar"
              :alt="currentUserData.full_name"
            />
            <img v-else src="/img/avatar-thumb.png" :alt="currentUserData.full_name" />
          </div>
        </div>

        <div style="width: 100%">
          <div class="comments__field-control">
            <AppMessageAttachmentPreview
              :files="commentArea.attachment.files"
              :tags="commentArea.attachment.tags"
              :editable="true"
              @remove-file="removeFile"
              @remove-tag="removeTag"
            />
            <span v-if="answerComment">{{ getFullUser(answerComment.sender.id) || answerComment.sender.name }},</span>
            <AppMessageInput
              :value="commentArea.message"
              @value-changed="changeCommentValue"
              placeholder="Добавить комментарий"
              textarea-height="auto"
              textarea-padding="0px 0px 20px"
              ref="textarea"
              @selection-range="setInputSelectionRange"
              @send-message="sendComment"
            />
            <AppMessageAttachment
              :link-tooltip="commentArea.attachment.linkTooltip"
              :tag-tooltip="commentArea.attachment.tagTooltip"
              :allow-inputs="commentAttachmentInputs"
              @toggle-link-tooltip="toggleLinkTooltip"
              @close-link-tooltip="closeLinkTooltip"
              @set-link-url="setLinkUrl"
              @toggle-tag-tooltip="toggleTagTooltip"
              @close-tag-tooltip="closeTagTooltip"
              @set-tag-text="setTagText"
              @attach-files="attachFiles"
              @attach-link="attachLink"
              @attach-tag="attachTag"
            />
          </div>

          <div style="display: flex">
          <AppButton :title="editComment ? 'Сохранить' : 'Отправить'"
                     type="third"
                     @click.native="sendComment"

          />

          <AppButton v-if="editComment || answerComment"
                      title="Отмена"
                      type="alt"
                      @click.native="clearMessageArea"
                      style="margin-left: 20px"
          />
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import AppMessageAttachment from '@/components/page/input/AppMessageAttachment'
import AppMessageAttachmentPreview from '@/components/page/input/AppMessageAttachmentPreview'
import AppMessageInput from '@/components/page/input/AppMessageInput'
import AppPopupControls from '@/components/page/popup/AppPopupControls'
import AppButton from '@/components/page/button/AppButton'
import axios from '@/utils/axios.js'
import { config } from '@/store/index'

export default {
  components: {
    AppButton,
    AppMessageInput,
    AppPopupControls,
    AppMessageAttachment,
    AppMessageAttachmentPreview
  },
  props: {
    initCount: {
      type: Number,
      default: 0
    },
    postId: Number,
    type: String
  },
  data () {
    return {
      isCommenting: false,
      showComments: false,
      shownCount: 5,
      count: this.initCount,
      comments: [],
      controlMenuIndex: null,
      editComment: null,
      answerComment: null,

      messageCopy: '',
      commentSelection: '',
      commentArea: {
        reply: {
          id: null,
          ownerId: null,
          quote: ''
        },
        message: '',
        attachment: {
          linkTooltip: {
            active: false,
            text: '',
            url: ''
          },
          tagTooltip: {
            active: false,
            text: ''
          },
          files: [],
          tags: []
          // filesToRemove: []
        }
      }
    }
  },
  computed: {
    currentUserData () {
      return this.$store.getters.currentUserData
    },
    commentAttachmentInputs () {
      return this.mediaBreakpoint !== 'desktop'
        ? { files: true, links: false, tags: false }
        : { files: true, links: true, tags: true } // tags was false
    },
    mediaBreakpoint () {
      return this.$store.getters.getMediaBreakpoint
    },
    convertType () {
      switch (this.type) {
        case 'EventMessage':
          return 'messages'
        case 'Activity':
          return 'activities'
        case 'Poll':
          return 'polls'
        default:
          return ''
      }
    }
  },
  methods: {
    getFullUser (id) {
      return this.$store.getters.getFullUserById(id)?.name?.trim()
    },
    getAnswerName (id) {
      return this.comments.find(item => item.id === id)
    },
    changeCommentValue (val) {
      this.commentArea.message = val
    },
    setInputSelectionRange (data) {
      this.messageCopy = data.input

      // берем Range если не пустой, проверяем на наличие вложенных тегов (иначе обертывание в ссылку ломается), может быть undefined если выделено одно слово.
      if (
        !data.range.collapsed &&
        (data.range.commonAncestorContainer.childElementCount === undefined ||
          data.range.commonAncestorContainer.childElementCount === 0)
      ) {
        this.commentSelection = data.range
      } else {
        this.commentSelection = ''
      }
    },
    toggleLinkTooltip () {
      const commentSelection = this.commentSelection.toString()

      if (commentSelection) {
        this.commentArea.attachment.linkTooltip.text = commentSelection
      }

      this.commentArea.attachment.linkTooltip.active = !this.commentArea.attachment.linkTooltip.active
    },
    closeLinkTooltip () {
      this.commentArea.attachment.linkTooltip.text = ''
      this.commentArea.attachment.linkTooltip.url = ''
      this.commentArea.attachment.linkTooltip.active = false
    },
    setLinkUrl (url) {
      this.commentArea.attachment.linkTooltip.url = url
    },
    attachLink () {
      const range = this.commentSelection
      const url = this.commentArea.attachment.linkTooltip.url.includes(
        'https://'
      )
        ? this.commentArea.attachment.linkTooltip.url
        : `https://${this.commentArea.attachment.linkTooltip.url}`

      if (range && this.commentArea.attachment.linkTooltip.url) {
        const linkTag = document.createElement('a')
        linkTag.setAttribute('target', '_blank')
        linkTag.setAttribute('title', url)
        linkTag.setAttribute('href', url)
        range.surroundContents(linkTag)

        this.commentArea.message = this.messageCopy.innerHTML
        this.closeLinkTooltip()
      }
    },
    toggleTagTooltip () {
      this.commentArea.attachment.tagTooltip.active = !this.commentArea.attachment.tagTooltip.active
    },
    closeTagTooltip () {
      this.commentArea.attachment.tagTooltip.text = ''
      this.commentArea.attachment.tagTooltip.active = false
    },
    setTagText (text) {
      this.commentArea.attachment.tagTooltip.text = text.replace(/\s/g, '')
    },
    attachTag () {
      const tag = this.commentArea.attachment.tagTooltip.text

      if (tag) {
        this.commentArea.attachment.tags.push(tag)
        this.closeTagTooltip()
      }
    },
    removeTag (index) {
      const tags = [...this.commentArea.attachment.tags]
      tags.splice(index, 1)
      this.commentArea.attachment.tags = tags
    },
    attachFiles (files) {
      const newFiles = Object.values(files)
      this.commentArea.attachment.files = this.commentArea.attachment.files.concat(
        newFiles
      )
    },
    removeFile ({ index }) {
      const files = this.commentArea.attachment.files
      files.splice(index, 1)
      this.commentArea.attachment.files = files
    },
    sendComment () {
      if (
        this.commentArea.message ||
        this.commentArea.attachment.files.length
      ) {
        const formData = new FormData()
        const files = this.commentArea.attachment.files

        for (let i = 0; i < files.length; ++i) {
          formData.append('files[]', files[i])
        }

        let commentId = null

        if (this.editComment) {
          commentId = this.editComment.comment_id || this.editComment.id
        } else if (this.answerComment) {
          commentId = this.answerComment.comment_id || this.answerComment.id
        }

        this.commentArea.message && formData.append('content', this.commentArea.message)
        this.commentArea.attachment.tags.length && formData.append('tags[]', this.commentArea.attachment.tags)
        this.currentUserData.id && formData.append('sender_id', this.currentUserData.id)
        commentId && formData.append('comment_id', commentId)
        this.postId && formData.append('post_id', this.postId)
        this.convertType && formData.append('type', this.convertType)

        if (this.editComment) {
          axios({ method: 'put', url: `/event-comments/${commentId}`, data: formData, ...config }).then(() => {
            this.getComments()
            this.isCommenting = false
            this.clearMessageArea()
          })
        } else {
          axios({ method: 'post', url: '/event-comments/', data: formData, ...config }).then(() => {
            this.getComments()
            this.clearMessageArea()
          })

          if (this.showComments) this.shownCount += 1
          else this.isCommenting = false
        }
      }
    },
    deleteComment (id) {
      this.controlMenuIndex = null
      axios.delete(`/event-comments/${id}/`, config).then(res => {
        this.getComments()
      })
    },
    setEdit (comment) {
      this.commentArea.message = comment.content
      this.commentArea.attachment.tags = comment.tags || []
      this.commentArea.attachment.files = comment.files || []
      this.editComment = comment
      this.isCommenting = true
    },
    setAnswer (comment) {
      this.answerComment = comment
      this.isCommenting = true
    },
    clearMessageArea () {
      this.commentArea.message = ''
      this.commentArea.attachment.tags = []
      this.commentArea.attachment.files = []
      this.editComment = null
      this.answerComment = null
    },

    replyMessage (data) {
      this.$store.dispatch('replyDialogMessage', data)
    },
    unReplyMessage () {
      this.$store.dispatch('unReplyDialogMessage')
    },
    getComments () {
      axios.get('/event-comments/posts/', { params: { [this.convertType]: [this.postId] }, ...config }).then(res => {
        const sortComments = res.data.sort((a, b) => {
          return new Date(a.created_at) - new Date(b.created_at)
        })

        const parsComments = []
        sortComments.forEach(item => {
          if (item.comment?.length) {
            parsComments.push(item)
            // console.log('nen', [...parsComments, ...item.comment])
            item.comment.forEach(subitem => parsComments.push(subitem))
          } else {
            parsComments.push(item)
          }
        })

        this.comments = parsComments
        this.count = parsComments.length
      })
    }
  },
  watch: {
    isCommenting (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.textarea.getFocus()
          this.$refs.commentField.scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          })
        })
      }
    },
    showComments (val) {
      if (!val) {
        this.isCommenting = false
        this.shownCount = 5
      } else {
        this.getComments()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/css/system/_vars";
@import "../../assets/css/system/_mixins";

.menu {
  position: relative;
  padding-right: 15px;
  padding-left: 15px;
  height: 3px;

  &__button {
    color: #95a4c0;
    cursor: pointer;
    width: 24px;
    margin-left: auto;
    transition: 0.3s;

    &:hover {
      color: $color_second_dark;
    }
  }

  &__controls {
    position: absolute;
    top: 25px;
    right: 12px;
    left: auto;
  }

  &_placeholder {
    height: 24px;
  }
}

.author {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 25px;
  padding-right: 30px;
  padding-left: 20px;
}

.comments {
  &__button {
    display: flex;
    align-items: center;
    background: none;
    padding: 0;
    margin-right: 23px;
    color: #697178;
    fill: #697178;
    cursor: pointer;

    &:hover {
      color: #0e619f;

      path {
        fill: #0e619f;
      }
    }
  }

  .author {
    margin: 0;
    padding: 0;
  }

  .comment-avatar {
    @include size(53px);
    border: 3px solid $color_main;
    margin-right: 10px;
  }

  &__control {
    display: flex;
    align-items: center;
    margin-top: 8px;

    &-count {
      margin-left: 5px;
    }
  }

  &__item {
    display: flex;
    align-items: flex-start;
    margin: 20px 0;

    &-content {
      background: #eaf8fe;
      border-radius: 5px;
      max-width: 397px;
      padding: 10px;
      font-size: 14px;
      line-height: 20px;
      letter-spacing: 0.04em;
      color: #697178;
      margin-bottom: 12px;
      word-wrap: break-word;
      white-space: pre-wrap;
      min-height: 68px;
      min-width: 128px;

      p {
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        letter-spacing: 0.04em;
        color: #1170b8;
        padding-right: 34px;
        margin-bottom: 5px;
      }

      img {
        margin-bottom: 5px;
      }
    }

    &-more {
      display: flex;
      justify-content: center;
      width: 100%;
      border-top: 1px solid #c4c4c4;
      padding-top: 20px;

      button {
        background: none;
        width: 176px;
        height: 40px;
        border: 1px solid #0e619f;
        cursor: pointer;
        color: #0e619f;
        cursor: pointer;
        transition: all 0.3s;

        &:hover {
          background: #0e619f;
          color: white;
        }
      }
    }
  }

  &__field {
    display: flex;
    align-items: flex-start;
    margin-top: 12px;

    &-control {
      width: 100%;
      height: auto;
      border: 1px solid #c4c4c4;
      border-radius: 3px;
      padding: 19px 17px 20px;
      margin-bottom: 12px;
    }
  }

  .replied-to {
    color: $color_second-light;

    &__close {
      color: $font_color_second;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        color: $color_second-light;
      }
    }
  }

  .quote {
    padding-left: 16px;
    font-size: 0.8em;
    font-weight: 300;
    font-style: italic;
    color: $font_color_second;
  }

  .fade-comments-enter {
    margin-bottom: -166px;
  }

  .fade-comments-enter-active {
    transform-origin: top;
    animation: scale-comments 0.3s;
  }

  .fade-comments-leave-active {
    transform-origin: top;
    animation: scale-comments 0.3s reverse;
  }

  @keyframes scale-comments {
    0% {
      margin-bottom: -166px;
      transform: scaleY(0);
      opacity: 0;
    }
    100% {
      margin-bottom: 0;
      transform: scaleY(1);
      opacity: 1;
    }
  }
}
</style>
